// Contato.
import dispensacao from './dispensacaoRepository'
import estornoDispensacao from './estornoDispensacaoRepository'
import gerenciamentoBnafar from './gerenciamentoBnafarRepository'
import medicamentoNaoPadronizado from './medicamentoNaoPadronizadoRepository'
import parametrizacao from './parametrizacaoRepository'
import livroPsicotropico from './livroPsicotropicoRepository'
import livroTalidomida from './livroTalidomidaRepository'
import relatorioDispensacaoPaciente from './relatorioDispensacaoPacienteRepository'
import altoCustoGerenciamentoProcesso from './altoCustoGerenciamentoProcessoRepository'
import relatorioSoaBnafar from './relatorioSoaBnafarRepository'
import relatorioDispensacao from './relatorioDispensacaoRepository'
import relatorioPacienteAtendido from './relatorioPacienteAtendidoRepository'
import relatorioMovimentacaoPsicotropico from './relatorioMovimentacaoPsicotropicoRepository'
import relatorioQuantitativoDispensacao from './relatorioQuantitativoDispensacaoRepository'
import relatorioEstornoDispensacao from './relatorioEstornoDispensacaoRepository'
import relatorioAltoCustoRetiradaPendente from './relatorioAltoCustoRetiradaPendenteRepository'
import relatorioAltoCustoProcesso from './relatorioAltoCustoProcessoRepository'
import relatorioAtendimentoDiario from './relatorioAtendimentoDiarioRepository'
import relatorioAltoCustoDispensacao from './relatorioAltoCustoDispensacaoRepository'
import relatorioAltoCustoProcessoPaciente from './relatorioAltoCustoProcessoPacienteRepository'
import relatorioAltoCustoEstatisticoCid from './relatorioAltoCustoEstatisticoCidRepository'
import supervisor from './supervisorRepository'
import filaAtendimentoRepository from './filaAtendimentoRepository'
import chamadaRepository from './chamadaRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/farmacia`

    return {
        chamada: chamadaRepository(baseUrl),
        dispensacao: dispensacao(baseUrl),
        estornoDispensacao: estornoDispensacao(baseUrl),
        filaAtendimento: filaAtendimentoRepository(baseUrl),
        gerenciamentoBnafar: gerenciamentoBnafar(baseUrl),
        medicamentoNaoPadronizado: medicamentoNaoPadronizado(baseUrl),
        parametrizacao: parametrizacao(baseUrl),
        livroPsicotropico: livroPsicotropico(baseUrl),
        livroTalidomida: livroTalidomida(baseUrl),
        relatorioDispensacaoPaciente: relatorioDispensacaoPaciente(baseUrl),
        altoCustoGerenciamentoProcesso: altoCustoGerenciamentoProcesso(baseUrl),
        relatorioSoaBnafar: relatorioSoaBnafar(baseUrl),
        relatorioDispensacao: relatorioDispensacao(baseUrl),
        relatorioPacienteAtendido: relatorioPacienteAtendido(baseUrl),
        relatorioMovimentacaoPsicotropico: relatorioMovimentacaoPsicotropico(baseUrl),
        relatorioQuantitativoDispensacao: relatorioQuantitativoDispensacao(baseUrl),
        relatorioEstornoDispensacao: relatorioEstornoDispensacao(baseUrl),
        relatorioAltoCustoRetiradaPendente: relatorioAltoCustoRetiradaPendente(baseUrl),
        relatorioAltoCustoProcesso: relatorioAltoCustoProcesso(baseUrl),
        relatorioAtendimentoDiario: relatorioAtendimentoDiario(baseUrl),
        relatorioAltoCustoDispensacao: relatorioAltoCustoDispensacao(baseUrl),
        relatorioAltoCustoProcessoPaciente: relatorioAltoCustoProcessoPaciente(baseUrl),
        relatorioAltoCustoEstatisticoCid: relatorioAltoCustoEstatisticoCid(baseUrl),
        supervisor: supervisor(baseUrl),

    }
}